// extracted by mini-css-extract-plugin
export default {"hilighted":"Row_hilighted__8wu+K","zero":"Row_zero__Jt9H6","placeHolderShimmer":"Row_placeHolderShimmer__H1CXO"};